import gql from "graphql-tag"

const USER = gql`
  query user($username: ID!) {
    user(username: $username) {
      email
      created
      enabled
      familyName
      givenName
      status
      updated
      username
      groups {
        name
        description
      }
    }
  }
`

export default USER
